import type { Dictionary, Translation } from '@/i18n/types';

const ro = {
  heading: 'Știri și articole',
  emptyState: 'Nu există înregistrări deocamdată. Reveniți mai târziu.',
  defaultCategory: 'Noutăți',
  paginationAria: 'Paginare',
  previous: 'Anterior',
  next: 'Următor',
  pageAria: 'Pagina {{page}}',
  currentPageAria: 'Pagina {{page}}, pagina curentă',
  backToList: 'Înapoi la știri',
  backToHome: 'Înapoi la pagina principală',
  loading: 'Se încarcă…',
  notFound: 'Articolul nu a fost găsit.',
  publishedOn: 'Publicat pe {{date}}',
  typeArticle: 'Articol',
  filtersAria: 'Filtrează știrile și articolele',
  filterCategory: 'Categorie',
  filterCategoryAria: 'Filtrează după categorie',
  filterAllCategories: 'Toate categoriile',
  filterType: 'Tip',
  filterTypeAria: 'Filtrează după tip',
  filterAllTypes: 'Știri și articole',
  typeNewsPlural: 'Știri',
  typeArticlePlural: 'Articole',
  resultsCount: '{{count}} rezultate',
  resultsCount_one: '{{count}} rezultat',
  resultsCount_few: '{{count}} rezultate',
  resultsCount_other: '{{count}} de rezultate',
  filteredEmptyState:
    'Nicio știre sau articol nu corespunde filtrelor. Încercați alte cuvinte sau resetați filtrele.',
  relatedHeading: 'Știri similare',
} as const;

const en = {
  heading: 'News and articles',
  emptyState: 'No records yet. Please check back later.',
  defaultCategory: 'News',
  paginationAria: 'Pagination',
  previous: 'Previous',
  next: 'Next',
  pageAria: 'Page {{page}}',
  currentPageAria: 'Page {{page}}, current page',
  backToList: 'Back to news',
  backToHome: 'Back to the home page',
  loading: 'Loading…',
  notFound: 'Article not found.',
  publishedOn: 'Published on {{date}}',
  typeArticle: 'Article',
  filtersAria: 'Filter news and articles',
  filterCategory: 'Category',
  filterCategoryAria: 'Filter by category',
  filterAllCategories: 'All categories',
  filterType: 'Type',
  filterTypeAria: 'Filter by type',
  filterAllTypes: 'News and articles',
  typeNewsPlural: 'News',
  typeArticlePlural: 'Articles',
  resultsCount: '{{count}} results',
  resultsCount_one: '{{count}} result',
  resultsCount_other: '{{count}} results',
  filteredEmptyState:
    'No news item or article matches the filters. Try other words or reset the filters.',
  relatedHeading: 'Related news',
} satisfies Translation<keyof typeof ro>;

export const publicNews = { ro, en } satisfies Dictionary;

export type PublicNewsKey = keyof typeof ro;
